import { Upload } from '@wellesley/openapi'
import isUploadReady, { isSafeFile } from '../isUploadReady'
import { ExtensionsMap } from '@wellesley/settings/types'

type HelperProps = {
  upload: Upload
  imgExtension?: ExtensionsMap['IMAGE']
}

const selectSmallestPreview = ({ upload, imgExtension }: HelperProps) => {
  if (!isUploadReady(upload)) return null

  const safeFiles = upload.files.filter(isSafeFile)

  const isVertical = safeFiles[0].meta.height! > safeFiles[0].meta.width!
  const bySide = isVertical ? 'height' : 'width'

  const typedFiles = safeFiles.filter((file) =>
    imgExtension?.includes(file.extension),
  )

  const sortedBySize = typedFiles.sort(
    (f1, f2) => f1.meta[bySide]! - f2.meta[bySide]!,
  )

  const smallestFile = sortedBySize[0]

  return smallestFile
}

export default selectSmallestPreview
